export enum SettingGroup {
  MONEYBAR = 'moneybar',
}
